import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'

const state = {
    work_progress_status_list: []
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}